import Highway from '@dogstudio/highway';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { gsap } from "gsap";
import 'overlayscrollbars';
import 'overlayscrollbars/css/OverlayScrollbars.css';

import en from './locales/en.json';
import pt from './locales/pt.json';

var tween;
var tweenMobile;

/* translation */
  /* int */
i18next
  .use(LanguageDetector)
  .init({
    initImmediate: false,
    debug: true,
    fallbackLng: 'pt',
    resources: {
      pt: {
        translation: pt
      },
      en: {
        translation: en
      }
    }
  }).then(function(t) {
    updateContent();
    updateLang();
  })

  /* change lang functions */ 
function changeLang(lang) {
  i18next.changeLanguage(lang)
  updateContent();
  updateLang();
}

Array.prototype.slice.call(document.querySelectorAll('.lang-btn')).forEach(function(e){
  e.addEventListener("click", function(){
    changeLang(e.getAttribute("name"))
  });
});

i18next.on('languageChanged', () => {
  updateContent();
});

function updateLang() {
  if (i18next.language == 'en') {
    document.querySelectorAll('.block-lang-en').forEach(
      item => item.style.textDecoration = 'underline'
    )
    document.querySelectorAll('.block-lang-pt').forEach(
      item => item.style.textDecoration = 'none'
    )
  } else {
    document.querySelectorAll('.block-lang-en').forEach(
      item => item.style.textDecoration = 'none'
    )
    document.querySelectorAll('.block-lang-pt').forEach(
      item => item.style.textDecoration = 'underline'
    )
  };
}

function updateContent() {
  switch (window.location.pathname) {
    case '/':
      document.querySelector('#home-title').innerHTML = i18next.t('home.title')
      document.querySelector('#home-subtitle').innerHTML = i18next.t('home.subtitle')
      document.querySelector('#home-text').innerHTML = i18next.t('home.text')
      document.querySelector('.block-btm-1 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-2 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-3 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-4 .block-link .block-btm__title').style.textDecoration = 'none';
      break;

    case '/project1.html':
      document.querySelector('#project1-title').innerHTML = i18next.t('project1.title')
      document.querySelector('#project1-subtitle').innerHTML = i18next.t('project1.subtitle')
      document.querySelector('#project1-text').innerHTML = i18next.t('project1.text')
      document.querySelector('.block-btm-1 .block-link .block-btm__title').style.textDecoration = 'underline';
      document.querySelector('.block-btm-2 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-3 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-4 .block-link .block-btm__title').style.textDecoration = 'none';
      break;

    case '/project2.html':
      document.querySelector('#project2-title').innerHTML = i18next.t('project2.title')
      document.querySelector('#project2-subtitle').innerHTML = i18next.t('project2.subtitle')
      document.querySelector('#project2-text').innerHTML = i18next.t('project2.text')
      document.querySelector('.block-btm-1 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-2 .block-link .block-btm__title').style.textDecoration = 'underline';
      document.querySelector('.block-btm-3 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-4 .block-link .block-btm__title').style.textDecoration = 'none';
      activeScroll();
      break;

    case '/project3.html':
      document.querySelector('#project3-title').innerHTML = i18next.t('project3.title')
      document.querySelector('#project3-subtitle').innerHTML = i18next.t('project3.subtitle')
      document.querySelector('#project3-text').innerHTML = i18next.t('project3.text')
      document.querySelector('.block-btm-1 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-2 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-3 .block-link .block-btm__title').style.textDecoration = 'underline';
      document.querySelector('.block-btm-4 .block-link .block-btm__title').style.textDecoration = 'none';
      break;

    case '/project4.html':
      document.querySelector('#project4-title').innerHTML = i18next.t('project4.title')
      document.querySelector('#project4-subtitle').innerHTML = i18next.t('project4.subtitle')
      document.querySelector('.block-btm-1 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-2 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-3 .block-link .block-btm__title').style.textDecoration = 'none';
      document.querySelector('.block-btm-4 .block-link .block-btm__title').style.textDecoration = 'underline';
      break;
  
    default:
      break;
  }

  document.querySelector('#section-title1').innerHTML = i18next.t('section-title1')
  document.querySelector('#section-title2').innerHTML = i18next.t('section-title2')

  document.querySelector('#mobile-section-title1').innerHTML = i18next.t('section-title1')
  document.querySelector('#mobile-section-title2').innerHTML = i18next.t('section-title2')
  document.querySelector('#mobile-section-title3').innerHTML = i18next.t('section-title3')

  document.querySelectorAll('.proj1-title-text').forEach(
    item => item.innerHTML = i18next.t('project1.title')
  )

  document.querySelectorAll('.proj2-title-text').forEach(
    item => item.innerHTML = i18next.t('project2.title')
  )

  document.querySelectorAll('.proj3-title-text').forEach(
    item => item.innerHTML = i18next.t('project3.title')
  )

  document.querySelectorAll('.proj4-title-text').forEach(
    item => item.innerHTML = i18next.t('project4.title')
  )
}

/* routing */

class Fade extends Highway.Transition{
  out ({from, to, done}) {
    new gsap.timeline({onComplete: done})
      .to(from, 0.25, {opacity: 0})
    done();
  }

  in({from, to, done}) {
    from.remove();
    updateContent();

    new gsap.timeline({onComplete: done})
      .fromTo(to, 0.25, {opacity: 0}, {opacity: 1})
  }
}

const H = new Highway.Core({
  transitions: {
    default: Fade
  }
});

Array.prototype.slice.call(document.querySelectorAll('[class*="block-link"], [class*="block-lang"]')).forEach(function(e){
  e.addEventListener("mouseover", changeDef);
});

function changeDef(event){
  tween = gsap.to(this, {duration: 0.2, opacity: 0.3});
  tween.play()
}

Array.prototype.slice.call(document.querySelectorAll('[class*="block-link"], [class*="block-lang"]')).forEach(function(e){
  e.addEventListener("mouseleave", changeDef2);
});

function changeDef2(event){
  tween = gsap.to(this, {duration: 0.2, opacity: 1});
  tween.play();
}

// by Taufik Nurrohman
function activeScroll() {
  document.addEventListener('wheel', (e) => {
    document.querySelector(".main-content__wrapper__inner").scrollLeft += e.deltaY;
})
}

activeScroll();

//bugfix

document.querySelector('.main-content__wrapper__inner').style.height = document.querySelector('.main-content').offsetHeight + 'px';

const resizeObserver = new ResizeObserver(e => {
  document.querySelector('.main-content__wrapper__inner').style.height = document.querySelector('.main-content').offsetHeight + 'px';
}
)

// start observing a DOM node
resizeObserver.observe(document.querySelector('.main-content'))

//open/close mobile menu

document.querySelector('#close-menu-btn').addEventListener("click", function() {
  toggleMenu("close")
});

document.querySelector('#open-menu-btn').addEventListener("click", function() {
  toggleMenu("open")
});

function toggleMenu(t) {
  if (t == 'close') {
    tweenMobile = gsap.to('.mobile-menu', {duration: 0.2, opacity: 0});
    tweenMobile.play();
    setTimeout(function() {
      document.querySelector('.mobile-menu').style.display = 'none'
    }, 300);
   
  } else if (t == 'open') {
    tweenMobile = gsap.to('.mobile-menu', {duration: 0.2, opacity: 1});
    tweenMobile.play();
    document.querySelector('.mobile-menu').style.display = 'block'
  }
}

document.querySelectorAll('.mobile-menu__block-link').forEach(
  item => item.addEventListener("click", function() {
    toggleMenu('close')
  })
)

function checkMobile() {
  let isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

  if (isMobile) {
    return true;
  }
}

// links

document.querySelector('.bproject1').addEventListener("click", function() {
  window.open("https://www.behance.net/gallery/67715461/SIDEMA", '_blank');
});

document.querySelector('.bproject2').addEventListener("click", function() {
  window.open("https://www.behance.net/gallery/72440355/GoodJob", '_blank');
});

document.querySelector('.bproject3').addEventListener("click", function() {
  window.open("https://www.behance.net/gallery/87633415/The-End-Direcao-de-video", '_blank');
});

document.querySelector('.bproject4').addEventListener("click", function() {
  window.open("https://www.behance.net/gallery/75429887/New-Deco-Typeface", '_blank');
});